import { useMutation } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';
import { useStore } from '../../store';

const { CONTROLLERS: { SECURITY: { VERSION } } } = USER;

interface IProps {
    payload:any
}

export const useMfaMutation = () => {
  const { getPersonalAccount, user: { customerId } } = useStore(state => state);
  const { accountExternalId } = getPersonalAccount();

  return useMutation(
    async ({ payload }: IProps) => {
      const { data } = await httpService.post(`${BASE_URL}/api/${VERSION}/mfa/user/${customerId}/${accountExternalId}/resendMfaAction`, payload);
      return data;
    },
  );
};
